import { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuthContext } from '../../../../../contexts/authContext';
import variables from '../../../../../shared/styles/settings.module.scss';
import { asyncDeleteTender } from '../../../../../services/tender.service';
import { LICITACIONES_EDIT } from '../../../../../routes/paths';

export const useTendersActions = (
    id: string | number,
    reloadData: () => void
) => {
    const navigate = useNavigate();
    const { modeTheme } = useAuthContext();
    const iconColor =
        modeTheme === 'darkMode' ? variables.darkColor : variables.primaryColor;

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${LICITACIONES_EDIT}/${id}`);
    };

    const handleDelete = () => {
        Swal.fire({
            title: 'Eliminar',
            text: '¿Está seguro que desea eliminar el registro?',
            icon: 'question',
            iconColor,
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: iconColor,
            confirmButtonText: 'SI',
            confirmButtonColor: iconColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteTender(id).then((body: any) => {
                    const isSuccessful = body.items !== undefined;
                    Swal.fire({
                        text: isSuccessful
                            ? 'Registro eliminado con éxito'
                            : 'Error al eliminar el registro',
                        icon: isSuccessful ? 'success' : 'error',
                        iconColor,
                    });
                    if (isSuccessful) reloadData();
                });
            }
        });
    };

    return {
        handleEdit,
        handleDelete,
    };
};
